import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { CLEARING_DOC_API } from "./apiRoutes";

interface UseGetClearingOwnerListProps {
  communityId: string;
  propertyId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getClearingOwnerList = async (communityId: string, propertyId: string) =>
  await axiosAuth.get(
    `${CLEARING_DOC_API(communityId)}/property/${propertyId}/owner-dropdown`
  );

const useGetClearingOwnerList = ({
  communityId,
  propertyId,
  queryParams,
}: UseGetClearingOwnerListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["clearing-owner-list", communityId, propertyId],
    queryFn: () => getClearingOwnerList(communityId, propertyId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetClearingOwnerList;
